
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPlay } from 'react-icons/fa';
import './AutomobileLogistics.css';

import heroBg from '../../Assets/Services/AutomobileLogistic/Background.png';
import whyChooseImage from '../../Assets/Services/AutomobileLogistic/Truck.png';
import oemImage from '../../Assets/Services/AutomobileLogistic/Ship.png';

const AutomobileLogistics = () => {

    // ScrollToTop component in App.js handles scrolling on route change

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <div className="automobile-logistics">

            {/* Hero Section */}
            <div className="automobile-hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <Container>
                    <motion.div
                        className="automobile-hero-content"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1>Automobile Logistics</h1>
                        <p>Safe, compliant vehicle transportation across India</p>
                    </motion.div>
                </Container>
            </div>

            {/* OEM-Focused End-to-End Logistics */}
            <section className="automobile-oem">
                <Container>
                    <Row>
                        <Col md={12}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={oemImage} alt="Automobile Cargo" className="img-fluid" />
                            </motion.div>
                        </Col>
                        <Col md={12} className="mt-4">
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>OEM-Focused End-to-End Logistics</h2>
                                <p>
                                    Janta Roadways delivers integrated automobile logistics solutions to leading OEMs across India.
                                    From passenger vehicles to chassis and commercial automotive cargo, our specialised fleet ensures
                                    secure, compliant, and on-time movement nationwide. With over four decades of industry expertise,
                                    we combine structured route planning, real-time tracking, preventive maintenance, and strict CMVR
                                    compliance to ensure damage-free vehicle delivery.
                                </p>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Why Choose Our Automobile Logistics */}
            <section className="automobile-why-choose">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Why Choose Our Automobile Logistics</h2>
                                <span className="subtitle">Engineered for precision. Delivered with responsibility.</span>

                                <ul className="why-choose-list">
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Dedicated automobile carriers for OEM transport</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Damage-free vehicle handling protocols</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> 100% CMVR-compliant fleet</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> GPS-enabled real-time tracking</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Trained drivers & SOP-driven operations</li>
                                </ul>
                            </motion.div>
                        </Col>
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={whyChooseImage} alt="Truck on Highway" className="why-choose-image shadow-sm" />
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Our Process Framework */}
            <section className="automobile-process">
                <Container>
                    <Row className="align-items-center">
                        <Col md={7}>
                            <motion.div
                                className="video-placeholder shadow"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <div className="play-button">
                                    <FaPlay size={20} />
                                </div>
                            </motion.div>
                        </Col>
                        <Col md={5}>
                            <motion.div
                                className="process-content"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Our Process Framework</h2>
                                <div className="process-steps">
                                    <div className="process-step">Requirement Assessment</div>
                                    <div className="process-step">Planning & Allocation</div>
                                    <div className="process-step">Execution & Monitoring</div>
                                    <div className="process-step">Delivery & Reporting</div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default AutomobileLogistics;
